module.exports = __webpack_public_path__ + "img/faqNegative.40c82a53.svg";